import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../imageWithBasePath'
import { all_routes } from '../../../feature-module/router/all_routes'
import { useAuth } from '../../../provider/AuthProvider'

const PLACEHOLDER_IMG =
  'https://ui-avatars.com/api/?name=User&background=random&size=128'

function ProfileDropdown() {
  const { logout, role, user } = useAuth()
  const [profilePicture, setProfilePicture] = useState<string | null>(null)

  // Get profile picture from localStorage and listen for changes
  useEffect(() => {
    const updateProfilePicture = () => {
      try {
        const userStr = localStorage.getItem('user')
        if (userStr) {
          const userData = JSON.parse(userStr)
          setProfilePicture(userData.profile_picture)
        }
      } catch (error) {
        console.error('Failed to parse user data from localStorage:', error)
      }
    }

    // Initial load
    updateProfilePicture()

    // Listen for localStorage changes
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'user' && e.newValue) {
        try {
          const userData = JSON.parse(e.newValue)
          setProfilePicture(userData.profile_picture)
        } catch (error) {
          console.error('Failed to parse user data from localStorage:', error)
        }
      }
    }

    // Listen for custom events (same-tab updates)
    const handleCustomStorageChange = () => {
      updateProfilePicture()
    }

    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('localStorageUpdate', handleCustomStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener(
        'localStorageUpdate',
        handleCustomStorageChange,
      )
    }
  }, [])

  return (
    <div className="dropdown profile-dropdown">
      <Link
        to="#"
        className="d-flex align-items-center"
        data-bs-toggle="dropdown"
      >
        <span className="avatar">
          <ImageWithBasePath
            srcApi={profilePicture}
            src={PLACEHOLDER_IMG}
            alt={user?.fullname || 'User'}
            className="img-fluid rounded-circle"
            fallbackSrc={PLACEHOLDER_IMG}
            isSquare={true}
          />
        </span>
      </Link>
      <div className="dropdown-menu dropdown-menu-end">
        <div className="profile-header d-flex align-items-center">
          <div className="avatar">
            <ImageWithBasePath
              srcApi={profilePicture}
              src={PLACEHOLDER_IMG}
              alt={user?.fullname || 'User'}
              className="img-fluid rounded-circle"
              fallbackSrc={PLACEHOLDER_IMG}
              isSquare={true}
            />
          </div>
          <div>
            <h6>{user?.fullname}</h6>
            <p>{user?.email}</p>
          </div>
        </div>
        <ul className="profile-body">
          <li>
            <Link
              className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
              to={
                role === 'admin'
                  ? all_routes.adminDashboard
                  : role === 'supervisor' ? all_routes.adminCBT : all_routes.userDashboard
              }
            >
              <i className="isax isax-home me-2" />
              Dashboard
            </Link>
          </li>
        </ul>
        <div className="profile-footer">
          <div
            onClick={logout}
            className="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
          >
            <i className="isax isax-logout me-2" />
            Logout
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileDropdown
